import React, { useEffect, useRef } from "react";
import Typewriter from "typewriter-effect";

interface TypewriterTextProps {
  text: string[] | string;
  speed?: number;
  className?: string;
  onComplete?: () => void;
  cursor?: boolean;
  cursorChar?: string;
}

export const TypewriterText: React.FC<TypewriterTextProps> = ({
  text,
  speed = 50,
  className = "",
  onComplete,
  cursor = true,
  cursorChar = "|",
}) => {
  const containerRef = useRef<HTMLSpanElement>(null);

  // Fix for the cursor spacing issue
  useEffect(() => {
    if (!containerRef.current) return;

    // This targets the Typewriter cursor element to fix spacing issues
    const cursorElement = containerRef.current.querySelector(
      ".Typewriter__cursor",
    );
    if (cursorElement) {
      (cursorElement as HTMLElement).style.marginLeft = "0";
    }
  }, []);

  return (
    <span ref={containerRef} className={className}>
      <Typewriter
        options={{
          strings: Array.isArray(text) ? text : [text],
          autoStart: true,
          delay: speed,
          cursor: cursor ? cursorChar : "",
          loop: Array.isArray(text) && text.length > 1,
          deleteSpeed: 30,
        }}
        onInit={(typewriter) => {
          if (onComplete) {
            typewriter.callFunction(onComplete);
          }
        }}
      />
    </span>
  );
};

export default TypewriterText;
